// This file is auto-generated by ./bin/rails stimulus:manifests:update_all
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AccommodationHubCarouselController from "./accommodation_hub_carousel_controller"
application.register("accommodation-hub-carousel", AccommodationHubCarouselController)

import AddToCalendarController from "./add_to_calendar_controller"
application.register("add-to-calendar", AddToCalendarController)

import AdyenPaymentsController from "./adyen_payments_controller"
application.register("adyen-payments", AdyenPaymentsController)

import ArticleController from "./article_controller"
application.register("article", ArticleController)

import ArticleNavigationController from "./article_navigation_controller"
application.register("article-navigation", ArticleNavigationController)

import AutoGrowTextareaController from "./auto_grow_textarea_controller"
application.register("auto-grow-textarea", AutoGrowTextareaController)

import BookingSessionSidebarController from "./booking_session_sidebar_controller"
application.register("booking-session-sidebar", BookingSessionSidebarController)

import BookingSessionSummaryBarController from "./booking_session_summary_bar_controller"
application.register("booking-session-summary-bar", BookingSessionSummaryBarController)

import CookiesBannerController from "./cookies_banner_controller"
application.register("cookies-banner", CookiesBannerController)

import DataLayerController from "./data_layer_controller"
application.register("data-layer", DataLayerController)

import DatepickerController from "./datepicker_controller"
application.register("datepicker", DatepickerController)

import DestinationsMapController from "./destinations_map_controller"
application.register("destinations-map", DestinationsMapController)

import DialogController from "./dialog_controller"
application.register("dialog", DialogController)

import DirectLoadingController from "./direct_loading_controller"
application.register("direct-loading", DirectLoadingController)

import DismissableController from "./dismissable_controller"
application.register("dismissable", DismissableController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import FilterSelectController from "./filter_select_controller"
application.register("filter-select", FilterSelectController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import HotelDetailsController from "./hotel_details_controller"
application.register("hotel-details", HotelDetailsController)

import HotelRatingFormController from "./hotel_rating_form_controller"
application.register("hotel-rating-form", HotelRatingFormController)

import HotelSearchController from "./hotel_search_controller"
application.register("hotel-search", HotelSearchController)

import HotelSearchFormController from "./hotel_search_form_controller"
application.register("hotel-search-form", HotelSearchFormController)

import HotelSearchResultController from "./hotel_search_result_controller"
application.register("hotel-search-result", HotelSearchResultController)

import ImageSwitcherController from "./image_switcher_controller"
application.register("image-switcher", ImageSwitcherController)

import InformationHubController from "./information_hub_controller"
application.register("information-hub", InformationHubController)

import LeafletController from "./leaflet_controller"
application.register("leaflet", LeafletController)

import LightboxGalleryController from "./lightbox_gallery_controller"
application.register("lightbox-gallery", LightboxGalleryController)

import LightboxGalleryOpenerController from "./lightbox_gallery_opener_controller"
application.register("lightbox-gallery-opener", LightboxGalleryOpenerController)

import MapController from "./map_controller"
application.register("map", MapController)

import NewReservationFormController from "./new_reservation_form_controller"
application.register("new-reservation-form", NewReservationFormController)

import PasswordController from "./password_controller"
application.register("password", PasswordController)

import PaymentFormController from "./payment_form_controller"
application.register("payment-form", PaymentFormController)

import PocketWifiFormController from "./pocket_wifi_form_controller"
application.register("pocket-wifi-form", PocketWifiFormController)

import RangeSelectorController from "./range_selector_controller"
application.register("range-selector", RangeSelectorController)

import ReadmoreController from "./readmore_controller"
application.register("readmore", ReadmoreController)

import RegionsMapController from "./regions_map_controller"
application.register("regions-map", RegionsMapController)

import ReservationController from "./reservation_controller"
application.register("reservation", ReservationController)

import RoomsController from "./rooms_controller"
application.register("rooms", RoomsController)

import SavePlaceController from "./save_place_controller"
application.register("save-place", SavePlaceController)

import SelectSortUrlController from "./select_sort_url_controller"
application.register("select-sort-url", SelectSortUrlController)

import ShareController from "./share_controller"
application.register("share", ShareController)

import StarsRatingController from "./stars_rating_controller"
application.register("stars-rating", StarsRatingController)

import UserLocalTimeController from "./user_local_time_controller"
application.register("user-local-time", UserLocalTimeController)

import UserProfileFormController from "./user_profile_form_controller"
application.register("user-profile-form", UserProfileFormController)

import VisitPlanController from "./visit_plan_controller"
application.register("visit-plan", VisitPlanController)
